import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';

const Challenges = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1628372095387-017d1099fc19)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.challenges.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.challenges.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.challenges.items.map((challenge, index) => (
            <Card 
              key={index} 
              className="card-hover border-none shadow-lg bg-white overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s`, borderRadius: '16px' }}
            >
              <CardContent className="p-0">
                <div className="h-56 overflow-hidden">
                  <img 
                    src={[
                      '/images/challenges/challenges-1.png',
                      '/images/challenges/challenges-2.png',
                      '/images/challenges/challenges-3.png'
                    ][index]}
                    alt={challenge.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3" style={{ color: '#2D4A8F' }}>
                    {challenge.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {challenge.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Challenges;
